import { useEffect, useRef } from 'react';
import './Cursor.css';

export default function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });
  const ringPos = useRef({ x: 0, y: 0 });
  const animationFrame = useRef(null);

  useEffect(() => {
    const isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) return;

    const moveCursor = () => {
      if (!dot.current || !ring.current) return;

      dot.current.style.transform = `translate(${mouse.current.x}px, ${mouse.current.y}px)`;

      ringPos.current.x += (mouse.current.x - ringPos.current.x) * 0.15;
      ringPos.current.y += (mouse.current.y - ringPos.current.y) * 0.15;

      ring.current.style.transform = `translate(${ringPos.current.x}px, ${ringPos.current.y}px)`;

      animationFrame.current = requestAnimationFrame(moveCursor);
    };

    const onMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
    };

    const onOver = (e) => {
      if (e.target.closest('a, button, input, textarea, select, [data-cursor]')) {
        ring.current?.classList.add('hovered');
      }
    };

    const onOut = () => {
      ring.current?.classList.remove('hovered');
    };

    const onMouseDown = () => {
      ring.current?.classList.add('active');
      dot.current?.classList.add('active');
    };

    const onMouseUp = () => {
      ring.current?.classList.remove('active');
      dot.current?.classList.remove('active');
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseover', onOver);
    window.addEventListener('mouseout', onOut);
    window.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mouseup', onMouseUp);

    animationFrame.current = requestAnimationFrame(moveCursor);

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseover', onOver);
      window.removeEventListener('mouseout', onOut);
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mouseup', onMouseUp);

      if (animationFrame.current) {
        cancelAnimationFrame(animationFrame.current);
      }
    };
  }, []);

  return (
    <div className="cursor-wrap">
      <div ref={dot} className="cursor-dot" />
      <div ref={ring} className="cursor-ring" />
    </div>
  );
}